import { render, staticRenderFns } from "./ExplorePage.vue?vue&type=template&id=5e48b8c0"
import script from "./ExplorePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExplorePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e48b8c0')) {
      api.createRecord('5e48b8c0', component.options)
    } else {
      api.reload('5e48b8c0', component.options)
    }
    module.hot.accept("./ExplorePage.vue?vue&type=template&id=5e48b8c0", function () {
      api.rerender('5e48b8c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/explore/ExplorePage.vue"
export default component.exports